import HttpFactory from '@/mixins/http.factory';
import { mapState, mapActions,mapGetters } from 'vuex'
export default {
	name:'notify-issue',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			editorObj:null,
			notifyData:{attachments:[],files:[]},
			zendeskInfo:{credentials:null,user:null,ticket:null,origin:null,app_guid:null,attachments:[],linkedItems:[]}

		}
	},
	created(){
		this.init();
	},
	beforeDestroy(){
        let _self=this;
        _self.fn().destoryEditorObj();
    },
	methods:{
		async init(){
			const _self=this;

			modalClient = ZAFClient.init();
			parentClient=null;
			let count=0;
			modalClient.on('send_data_to_modal', async (data)=> {
				parentClient = modalClient.instance(data.parentClientGuid)
				//_self.zendeskInfo=data;
				await _self.getAppData(data);
				count++;
				if(count==1){
					_self.fn().createHtmlEditor('editor');
					setTimeout(function(){_self.initDropzone(data);},500);
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				if(error){
					return;
				}
				_self.notifyData.files=_self.notifyData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.notifyData.files=_self.notifyData.files.filter(d=>d.id!=file.id);
		},
		removeConfirmModal_notused(file){
			let _self=this;
			var size={ width: '30vw',height: '8vw'};
			_self.zendeskInfo.msg=`Are you sure? You want to remove file ${file.fileName}!!!`
			let triggerInstance=`confirm-dialog_file${file.id}`;
			let cbInstance=`remove-confirm-dialog_file${file.id}`;
			let action=`confirm-dialog?fileId=${file.id}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,cbInstance,_self.zendeskInfo,function(response){
				if(response.Success && response.type=='confirmed'){
					_self.removeFile(file);
				}
			});
		},
		async getAppData(zendeskInfo){
			const _self=this;
			_self.loading=true;
			let response=await _self.post(`getAppData/${zendeskInfo.ticket.id}`,{auth:zendeskInfo.credentials});
			if(response.data && response.data.Success){
				zendeskInfo.attachments=response.data.Data.attachments;
				zendeskInfo.linkedItems=response.data.Data.linkedTickets.map(d=>d.issueId).toString();
				_self.zendeskInfo=zendeskInfo;
			}
			_self.loading=false;
		},
		handleFileUpload(){
			const _self=this;
			let file=_self.$refs.file.files[0];
			_self.fn().getBase64(file,function(error,response){
				_self.notifyData.files.push({fileName:file.fileName,base64:response}); 
			});
		},
		notifyIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
			let data=_self.notifyData;
			if(_self.editorObj)
            	data.commentText=_self.fn().getHtmlEditorContent();
            
			if(!data.commentText || data.commentText.trim()==''){
				_self.userMsg={show:true,type:'danger',list:[`Please enter the comment description`]}
				return;
			}
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			data.hdTicketId=_self.zendeskInfo.ticket.id;
			let url=`zendesk/notifylinked/${data.hdTicketId}`
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Linked workitems notified Successfully`]}
					_self.userMsg=userMsg;
					//_self.sendDataToParent(response.data);
					_self.fn().clearHtmlEditorContent();
					_self.closeDialog();
				}
				_self.data=response.data.Data;
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	}
}

